import * as api from 'src/api/firstVisitScoring';

import { getUrlParams } from '../helpers';
import { runToast } from '../tools';

export const calculateFirstVisitScoringForCurrentReading = async () => {
  const {
    id: clinicalTrialId,
    taskId: parentTaskId,
    subTaskId: taskId,
  } = getUrlParams() ?? {};

  if (!clinicalTrialId || !parentTaskId || !taskId) {
    throw new Error(
      'Cannot read the first visit scoring: the reading route is not resolved'
    );
  }

  try {
    const { data } = await api.calculateFirstVisitScoring({
      clinicalTrialId,
      parentTaskId,
      taskId,
    });

    return data;
  } catch (error) {
    runToast('error', 'Failed to load the first visit scoring');
    console.error('Calculate first visit scoring error', error);

    throw error;
  }
};
